import {
  AGENT_RUN_FAILED_BODY_KEYS,
  AGENT_RUN_FAILURE_REASONS,
} from "../constants/notifications";
import type {
  IRunFailedNotificationView,
  TAgentRunFailedBodyKey,
  TRunFailedNotification,
  TWorkflowRunFailedBodyKey,
} from "../types/notifications";
import {
  EAgentRunFailureReason,
  ENotificationType,
} from "../types/notifications";

export const isAgentRunFailureReason = (
  value: string,
): value is EAgentRunFailureReason => AGENT_RUN_FAILURE_REASONS.includes(value);

// NOTE: NSAI-7884 — a reason this client does not know reads as the generic
// "a run failed" sentence rather than a missing key.
export const resolveAgentRunFailedBodyKey = (
  reason: string,
): TAgentRunFailedBodyKey =>
  AGENT_RUN_FAILED_BODY_KEYS[
    isAgentRunFailureReason(reason) ? reason : EAgentRunFailureReason.ERROR
  ];

export const resolveWorkflowRunFailedBodyKey = (
  wasAutoPaused: boolean,
): TWorkflowRunFailedBodyKey =>
  wasAutoPaused
    ? "type.workflow_run_failed.body_paused"
    : "type.workflow_run_failed.body";

export const resolveRunFailedNotificationView = (
  notification: TRunFailedNotification,
): IRunFailedNotificationView => {
  if (notification.type === ENotificationType.AGENT_RUN_FAILED) {
    const { data } = notification;
    return {
      automationUuid: data.agentUuid,
      projectUuid: data.projectUuid,
      isWorkflow: false,
      titleKey: "type.agent_run_failed.title",
      bodyKey: resolveAgentRunFailedBodyKey(data.reason),
      lastErrorKey: "type.agent_run_failed.last_error",
      automationName: data.agentName,
      error: data.error,
    };
  }
  const { data } = notification;
  return {
    automationUuid: data.workflowUuid,
    projectUuid: data.projectUuid,
    isWorkflow: true,
    titleKey: "type.workflow_run_failed.title",
    bodyKey: resolveWorkflowRunFailedBodyKey(data.wasAutoPaused),
    lastErrorKey: "type.workflow_run_failed.last_error",
    automationName: data.workflowName,
    error: data.error,
  };
};
